import { request, FetchOptions } from './http';
import { authFallback } from '../actions/authentication/authentication';
import { ReduxStore } from '../store/ReduxStore';

export class HttpClient {
  static inject = [ReduxStore];
  constructor(private reduxStore: ReduxStore) {}

  request = async (options: FetchOptions) => {
    try {
      return await request(options);
    } catch (error) {
      // get authoriztion from options header remove Bearer and decode if iss includes cognito-idp then dispatch authFallback
      const authHeader = options.headers
        ? options.headers['Authorization'] || options.headers['authorization']
        : null;
      if (authHeader) {
        const token = authHeader.replace('Bearer ', '');
        const decodedToken = token
          ? JSON.parse(atob(token.split('.')[1]))
          : null;
        const iss = decodedToken ? decodedToken?.iss : null;
        if (iss && iss.includes('cognito-idp')) {
          // Token is from Cognito, no need to dispatch authFallback
        } else {
          if (error.status === 401) {
            this.reduxStore.dispatch(authFallback(error)!);
          }
        }
        throw error;
      }
    }
  };
}
